<div
  class="main-container"
  [ngClass]="{ disabled: isDisabled }"
  [formGroup]="timeFormGroup"
>
  <div
    class="time-head"
    [ngStyle]="
      showDropdown && !hideAll && index == currIndex ? { display: 'none' } : ''
    "
    (click)="onSelectClick()"
  >
    <div class="text time-text">
      {{ showOnlyTime(timeFormGroup.get('time1').value) }}
      {{ 'TO' | fallbackTranslate }}
      {{ showOnlyTime(timeFormGroup.get('time2').value) }}
    </div>
  </div>
  <div
    class="time-dropdown"
    [ngStyle]="
      showDropdown && !hideAll && index == currIndex
        ? { display: 'block' }
        : { display: 'none' }
    "
  >
    <div class="set-time-label">{{ 'SET_TIME' | fallbackTranslate }}</div>
    <div class="p-16">
      <div class="flex-align-center time-box-container">
        <div class="time-box">
          <div class="start-at">{{ 'START_TIME' | fallbackTranslate | uppercase }}</div>
          <div class="input-time">
            <nz-time-picker
              formControlName="time1"
              [nzPlaceHolder]="'SELECT_TIME' | fallbackTranslate"
              [nzUse12Hours]="true"
              nzFormat="h:mm a"
              #timestart
              (nzOpenChange)="onTimePickerChange($event, 'start')"
              (ngModelChange)="onTimePickerValueChange($event)"
            ></nz-time-picker>
          </div>
        </div>

        <div class="time-box">
          <div class="ends-at">{{ 'END_TIME' | fallbackTranslate | uppercase }}</div>
          <div class="input-time">
            <nz-time-picker
              formControlName="time2"
              [nzPlaceHolder]="'SELECT_TIME' | fallbackTranslate"
              [nzUse12Hours]="true"
              nzFormat="h:mm a"
              #timeend
              (nzOpenChange)="onTimePickerChange($event, 'end')"
              (ngModelChange)="onTimePickerValueChange($event)"
            ></nz-time-picker>
          </div>
        </div>
        <div class="m-t-14" *ngIf="isCustomBtn && isBothTimeSelected" translate>
          {{ isSameDay ? 'SAME_DAY' : 'NEXT_DAY' }}
        </div>
      </div>
      <div class="alert-text" *ngIf="timingError && !isCustomBtn">
        {{'SHOW_END_TIME_ERROR' | fallbackTranslate}}
      </div>
      <div class="done">
        <div
          class="btn-done type-1 wd-100 fw-600 fs-14 m-t-20"
          (click)="onDoneClick()"
          [ngClass]="{
            'opacity-half' : timingError && !isCustomBtn
          }"
        >
          <span *ngIf="isCustomBtn">
            {{ 'SET_TIME_FROM' | fallbackTranslate }}
            {{ showOnlyTime(timeFormGroup?.get('time1')?.value) }}
            {{ 'TO' | fallbackTranslate }}
            {{ showOnlyTime(timeFormGroup?.get('time2')?.value) }}
            <span *ngIf="isBothTimeSelected" translate>
              {{ isSameDay ? 'SAME_DAY' : 'NEXT_DAY' }}
            </span>
          </span>
          <span *ngIf="!isCustomBtn">
            {{ 'DONE' | fallbackTranslate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
